import { Text } from '@querodelivery/uni-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRight } from '@fortawesome/pro-solid-svg-icons';
import type { MissionChangeLogChange } from '../../types';
import { formatMissionHistoryValue } from '../../utils/format-mission-history-value';
import { getMissionHistoryFieldLabel } from '../../utils/get-mission-history-field-label';
import { MissionChangeLogDiffValue } from '../mission-change-log-diff-value/mission-change-log-diff-value';
import styles from './mission-change-log-diff-row.module.scss';

type MissionChangeLogDiffRowProps = {
  diffRow: MissionChangeLogChange;
};

export const MissionChangeLogDiffRow = ({
  diffRow,
}: MissionChangeLogDiffRowProps) => {
  const { field, position, previousValue, currentValue } = diffRow;
  const hasPrevious = previousValue != null;
  const hasNew = currentValue != null;

  return (
    <div className={styles.container}>
      <Text
        fontSize="xs"
        lineHeight="lg"
        fontWeight="medium"
        className={styles.field}
        tone="supporting"
      >
        {getMissionHistoryFieldLabel(field, position)}
      </Text>
      <div className={styles.comparison}>
        {hasPrevious && (
          <MissionChangeLogDiffValue
            value={formatMissionHistoryValue(field, previousValue)}
            variant="previous"
          />
        )}
        {hasPrevious && hasNew && (
          <span className={styles.arrow}>
            <FontAwesomeIcon icon={faRight} size="sm" />
          </span>
        )}
        {hasNew && (
          <MissionChangeLogDiffValue
            value={formatMissionHistoryValue(field, currentValue)}
            variant="new"
          />
        )}
      </div>
    </div>
  );
};
